import React from 'react';
import { graphql, Link } from 'gatsby';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import styled from '@emotion/styled';
import { PostList } from 'components';
import { Layout2 } from 'layouts';
import Wordlist from '../components/wordlist';



const PostWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 4rem 4rem 1rem 4rem;
  @media (max-width: 1000px) {
    margin: 4rem 2rem 1rem 2rem;
  }
  @media (max-width: 700px) {
    margin: 4rem 1rem 1rem 1rem;
  }
`;

const Search = ({ data }) => {
  const { edges } = data.allMarkdownRemark;
  return (
    <Layout2>
      <Helmet title={'料理サイトの人気レシピを簡単検索「Cookle」'}
        description={'クックパッド、ナディア、クラシルのレシピを人気順👑で見れます。冷蔵庫の食材を組み合わせてすぐ献立を決められます。レシピは人気順だからハズレなし！'}
      />
      <div
        style={{
          background: 'tomato',
          marginBottom: '0.2rem',
        }}
      >
        <div
          style={{
            margin: '0 auto',
            maxWidth: 960,
            padding: '0.2rem 1.0875rem',
          }}
        >
          <h1 style={{ margin: 0, maxWidth: 960 }}>
            <Link
              to="/"
              style={{
                color: 'white',
                textDecoration: 'none',
                fontSize: '3.5vmin',
              }}
            >料理サイトの人気レシピを簡単検索「Cookle」
            </Link>
          </h1>
        </div>
      </div>
      <div
        style={{
          margin: '0 auto',
          maxWidth: 960,
          padding: '0px 1.0875rem 1.45rem',
          paddingTop: 0,

        }}
      >
        <Wordlist />

      </div>
      <hr className="linedashed" />
      <br />

      <Link to="/about/" className="center">くっくるの使い方</Link>
      <br></br>
      <Link to="/AddHome" className="center">
        くっくるをホーム画面に追加
        <span role="img" aria-label="question mark">
          &#x2754;
        </span>
      </Link>

      <br />
      <br />
      <hr className="linedashed" />

      <PostWrapper>
        {edges.map(({ node }) => (
          <PostList
            key={node.id}
            cover={node.frontmatter.cover.childImageSharp.fluid}
            path={node.frontmatter.path}
            title={node.frontmatter.title}
            date={node.frontmatter.date}
            excerpt={node.excerpt}
          />
        ))}
      </PostWrapper>
    </Layout2>
  );
};
export default Search;

Search.propTypes = {
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      edges: PropTypes.arrayOf(
        PropTypes.shape({
          node: PropTypes.shape({
            excerpt: PropTypes.string,
            frontmatter: PropTypes.shape({
              cover: PropTypes.object.isRequired,
              path: PropTypes.string.isRequired,
              title: PropTypes.string.isRequired,
              date: PropTypes.string.isRequired,
              tags: PropTypes.array,
            }),
          }),
        }).isRequired
      ),
    }),
  }),
};

export const query = graphql`
  query {
    allMarkdownRemark(
      limit: 6
      sort: { order: DESC, fields: [frontmatter___date] }
    ) {
      edges {
        node {
          id
          excerpt(pruneLength: 75)
          frontmatter {
            title
            path
            tags
            date(formatString: "MM.DD.YYYY")
            cover {
              childImageSharp {
                fluid(
                  maxWidth: 1000
                  quality: 90
                  traceSVG: { color: "#2B2B2F" }
                ) {
                  ...GatsbyImageSharpFluid_withWebp_tracedSVG
                }
              }
            }
          }
        }
      }
    }
   
  }
`;
